<p-sidebar class="filter-sidebar" [(visible)]="isVisible" [position]="isMobile ? 'bottom' : 'right'" [blockScroll]="true" [showCloseIcon]="false" (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="header-container">
      <span class="title">Ordenar y filtrar</span>
      <button class="custom-button-clear close" (click)="cancel()"><i class="icon-close"></i></button>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="filters-container">
      @if (hasActiveFiltersInForm) {
        <div class="active-filters">
          @if (form.controls.amenities.value?.length) {
            @for (amenity of form.controls.amenities.value; track amenity) {
              <div class="chip" (click)="deleteValue(form.controls.amenities, amenity)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ amenityLabels[amenity] }}</p>
              </div>
            }
          }
          @if (form.controls.areaMax.value && form.controls.areaMin.value) {
            <div class="chip" (click)="resetControls([form.controls.areaMax, form.controls.areaMin])">
              <i class="icon-cancel-fill"></i>
              <p class="label">Superficie: {{ form.controls.areaMin.value }} - {{ form.controls.areaMax.value }} m²</p>
            </div>
          } @else if (form.controls.areaMax.value) {
            <div class="chip" (click)="resetControls(form.controls.areaMax)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Superficie: hasta {{ form.controls.areaMax.value }} m²</p>
            </div>
          } @else if (form.controls.areaMin.value) {
            <div class="chip" (click)="resetControls(form.controls.areaMin)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Superficie: desde {{ form.controls.areaMin.value }} m²</p>
            </div>
          }
          @if (form.controls.bathroomsMax.value && form.controls.bathroomsMin.value) {
            <div class="chip" (click)="resetControls([form.controls.bathroomsMax, form.controls.bathroomsMin])">
              <i class="icon-cancel-fill"></i>
              <p class="label">Baños: {{ form.controls.bathroomsMin.value }} - {{ form.controls.bathroomsMax.value }}</p>
            </div>
          } @else if (form.controls.bathroomsMax.value) {
            <div class="chip" (click)="resetControls(form.controls.bathroomsMax)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Baños: hasta {{ form.controls.bathroomsMax.value }}</p>
            </div>
          } @else if (form.controls.bathroomsMin.value) {
            <div class="chip" (click)="resetControls(form.controls.bathroomsMin)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Baños: desde {{ form.controls.bathroomsMin.value }}</p>
            </div>
          }
          @if (form.controls.bedroomsMax.value && form.controls.bedroomsMin.value) {
            <div class="chip" (click)="resetControls([form.controls.bedroomsMax, form.controls.bedroomsMin])">
              <i class="icon-cancel-fill"></i>
              <p class="label">Recámaras: {{ form.controls.bedroomsMin.value }} - {{ form.controls.bedroomsMax.value }}</p>
            </div>
          } @else if (form.controls.bedroomsMax.value) {
            <div class="chip" (click)="resetControls(form.controls.bedroomsMax)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Recámaras: hasta {{ form.controls.bedroomsMax.value }}</p>
            </div>
          } @else if (form.controls.bedroomsMin.value) {
            <div class="chip" (click)="resetControls(form.controls.bedroomsMin)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Recámaras: desde {{ form.controls.bedroomsMin.value }}</p>
            </div>
          }
          @if (form.controls.developerIds.value?.length) {
            @for (developerId of form.controls.developerIds.value; track developerId) {
              <div class="chip" (click)="deleteValue(form.controls.developerIds, developerId)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ developersMap.get(developerId)?.name ?? 'Desarrollador ' + developerId }}</p>
              </div>
            }
          }
          @if (form.controls.municipality.value) {
            <div class="chip" (click)="resetControls(form.controls.municipality)">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ form.controls.municipality.value }}</p>
            </div>
          }
          @if (form.controls.phases.value?.length) {
            @for (phase of form.controls.phases.value; track phase) {
              <div class="chip" (click)="deleteValue(form.controls.phases, phase)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ phaseLabels[phase] }}</p>
              </div>
            }
          }
          @if (form.controls.priceMax.value && form.controls.priceMin.value) {
            <div class="chip" (click)="resetControls([form.controls.priceMax, form.controls.priceMin])">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ form.controls.priceMin.value | currencyFormatter: currency }} - {{ form.controls.priceMax.value | currencyFormatter: currency }} {{ currency }}</p>
            </div>
          } @else if (form.controls.priceMax.value) {
            <div class="chip" (click)="resetControls(form.controls.priceMax)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Hasta {{ form.controls.priceMax.value | currencyFormatter: currency }} {{ currency }}</p>
            </div>
          } @else if (form.controls.priceMin.value) {
            <div class="chip" (click)="resetControls(form.controls.priceMin)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Desde {{ form.controls.priceMin.value | currencyFormatter: currency }} {{ currency }}</p>
            </div>
          }
          @if (form.controls.settlements.value?.length) {
            @for (settlement of form.controls.settlements.value; track settlement) {
              <div class="chip" (click)="deleteValue(form.controls.settlements, settlement)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ settlement }}</p>
              </div>
            }
          }
          @if (form.controls.state.value) {
            <div class="chip" (click)="resetControls(form.controls.state, stateOptionDefault)">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ form.controls.state.value }}</p>
            </div>
          }
          @if (form.controls.types.value?.length) {
            @for (type of form.controls.types.value; track type) {
              <div class="chip" (click)="deleteValue(form.controls.types, type)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ typeLabels[type] }}</p>
              </div>
            }
          }
          @if (form.controls.sortBy.value?.field !== 'default') {
            <div class="chip" (click)="resetControls(form.controls.sortBy, sortOptionDefault)">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ getSortByLabel(form.controls.sortBy.value) }}</p>
            </div>
          }
        </div>
      }
      <p-accordion class="accordion-filters">
        <form [formGroup]="form" class="form">
          <p-accordionTab class="accordion-tab" header="Ordenar" iconPos="end">
            @for (option of sortOptions; track $index) {
              <div class="option">
                <label [for]="'filter-sort-' + $index">{{ option.label }}</label>
                <input class="app-radio" type="radio" name="filter-sort" [id]="'filter-sort-' + $index" [value]="option.value" [formControl]="form.controls.sortBy" />
              </div>
            }
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Estado" iconPos="end">
            <app-retryable-section [error]="statesViewState.status === 'error'" [loading]="statesViewState.status === 'loading'" (retry)="loadStates()">
              @if (statesViewState.status === 'success') {
                <div class="option">
                  <label for="filter-state-all">Todos los estados</label>
                  <input class="app-radio" type="radio" name="filter-state" id="filter-state-all" [value]="stateOptionDefault" [formControl]="form.controls.state" />
                </div>
                @for (state of statesViewState.value; track $index) {
                  <div class="option">
                    <label [for]="'filter-state-' + $index">{{ state }}</label>
                    <input class="app-radio" type="radio" name="filter-state" [id]="'filter-state-' + $index" [value]="state" [formControl]="form.controls.state" />
                  </div>
                }
              }
            </app-retryable-section>
          </p-accordionTab>
          @if (form.controls.state.value) {
            <p-accordionTab class="accordion-tab" header="Municipio" iconPos="end">
              <app-retryable-section [error]="municipalitiesViewState.status === 'error'" [loading]="municipalitiesViewState.status === 'loading'" (retry)="loadMunicipalities()">
                @if (municipalitiesViewState.status === 'success') {
                  <div class="option">
                    <label for="filter-municipality-all">Todos los municipios</label>
                    <input class="app-radio" type="radio" name="filter-municipality" id="filter-municipality-all" [value]="null" [formControl]="form.controls.municipality" />
                  </div>
                  @for (municipality of municipalitiesViewState.value; track municipality) {
                    <div class="option">
                      <label [for]="'filter-municipality-' + $index">{{ municipality }}</label>
                      <input class="app-radio" type="radio" name="filter-municipality" [id]="'filter-municipality-' + $index" [value]="municipality" [formControl]="form.controls.municipality" />
                    </div>
                  }
                }
              </app-retryable-section>
            </p-accordionTab>
            @if (form.controls.municipality.value) {
              <p-accordionTab class="accordion-tab" header="Colonias" iconPos="end">
                <app-retryable-section [error]="settlementsViewState.status === 'error'" [loading]="settlementsViewState.status === 'loading'" (retry)="loadSettlements()">
                  @if (settlementsViewState.status === 'success') {
                    @for (settlement of settlementsViewState.value; track settlement) {
                      <div class="option">
                        <label [for]="'filter-settlement-' + $index">{{ settlement }}</label>
                        <input class="app-checkbox" type="checkbox" [id]="'filter-settlement-' + $index" [checked]="form.controls.settlements.value?.includes(settlement) ?? false" (change)="onArrayValueToggle($event, form.controls.settlements, settlement)" />
                      </div>
                    }
                  }
                </app-retryable-section>
              </p-accordionTab>
            }
          }
          <p-accordionTab class="accordion-tab" header="Rango de precios" iconPos="end">
            <div class="input-filter-container">
              <label for="min-price">Desde</label>
              <input appNumericInput class="input app-input" id="min-price" type="text" inputmode="decimal" [formControl]="form.controls.priceMin" [currency]="currency" [locale]="locale" placeholder="$" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
            <div class="input-filter-container">
              <label for="max-price">Hasta</label>
              <input appNumericInput class="input app-input" id="max-price" type="text" inputmode="decimal" [formControl]="form.controls.priceMax" [currency]="currency" [locale]="locale" placeholder="$" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Superficie" iconPos="end">
            <div class="input-filter-container">
              <label for="min-area">Desde</label>
              <input appNumericInput class="input app-input" id="min-area" type="text" inputmode="decimal" [formControl]="form.controls.areaMin" [locale]="locale" suffix=" m²" placeholder="m²" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
            <div class="input-filter-container">
              <label for="max-area">Hasta</label>
              <input appNumericInput class="input app-input" id="max-area" type="text" inputmode="decimal" [formControl]="form.controls.areaMax" [locale]="locale" suffix=" m²" placeholder="m²" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Recámaras" iconPos="end">
            <div class="input-filter-container">
              <label for="min-bedrooms">Desde</label>
              <input appNumericInput class="input app-input" id="min-bedrooms" type="text" inputmode="numeric" [formControl]="form.controls.bedroomsMin" [locale]="locale" placeholder="0" [minimumFractionDigits]="0" [maximumFractionDigits]="0" />
            </div>
            <div class="input-filter-container">
              <label for="max-bedrooms">Hasta</label>
              <input appNumericInput class="input app-input" id="max-bedrooms" type="text" inputmode="numeric" [formControl]="form.controls.bedroomsMax" [locale]="locale" placeholder="0" [minimumFractionDigits]="0" [maximumFractionDigits]="0" />
            </div>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Baños" iconPos="end">
            <div class="input-filter-container">
              <label for="min-bathrooms">Desde</label>
              <input appNumericInput class="input app-input" id="min-bathrooms" type="text" inputmode="numeric" [formControl]="form.controls.bathroomsMin" [locale]="locale" placeholder="0" [minimumFractionDigits]="0" [maximumFractionDigits]="0" />
            </div>
            <div class="input-filter-container">
              <label for="max-bathrooms">Hasta</label>
              <input appNumericInput class="input app-input" id="max-bathrooms" type="text" inputmode="numeric" [formControl]="form.controls.bathroomsMax" [locale]="locale" placeholder="0" [minimumFractionDigits]="0" [maximumFractionDigits]="0" />
            </div>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Tipo de propiedad" iconPos="end">
            @for (option of typeOptions; track option.value) {
              <div class="option">
                <label [for]="'filter-type-' + option.value">{{ option.label }}</label>
                <input class="app-checkbox" type="checkbox" [id]="'filter-type-' + option.value" [checked]="form.controls.types.value?.includes(option.value) ?? false" (change)="onArrayValueToggle($event, form.controls.types, option.value)" />
              </div>
            }
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Desarrolladores" iconPos="end">
            <app-retryable-section [error]="developersViewState.status === 'error'" [loading]="developersViewState.status === 'loading'" (retry)="loadDevelopers()">
              @if (developersViewState.status === 'success') {
                @for (developer of developersViewState.value; track developer.id) {
                  <div class="option">
                    <label [for]="'filter-developer-' + developer.id">{{ developer.name }}</label>
                    <input class="app-checkbox" type="checkbox" [id]="'filter-developer-' + developer.id" [checked]="form.controls.developerIds.value?.includes(developer.id) ?? false" (change)="onArrayValueToggle($event, form.controls.developerIds, developer.id)" />
                  </div>
                }
              }
            </app-retryable-section>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Fase del proyecto" iconPos="end">
            @for (option of phaseOptions; track option.value) {
              <div class="option">
                <label [for]="'filter-phase-' + option.value">{{ option.label }}</label>
                <input class="app-checkbox" type="checkbox" [id]="'filter-phase-' + option.value" [checked]="form.controls.phases.value?.includes(option.value) ?? false" (change)="onArrayValueToggle($event, form.controls.phases, option.value)" />
              </div>
            }
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Amenidades" iconPos="end">
            @for (option of amenityOptions; track option.value) {
              <div class="option">
                <label [for]="'filter-amenity-' + option.value">{{ option.label }}</label>
                <input class="app-checkbox" type="checkbox" [id]="'filter-amenity-' + option.value" [checked]="form.controls.amenities.value?.includes(option.value) ?? false" (change)="onArrayValueToggle($event, form.controls.amenities, option.value)" />
              </div>
            }
          </p-accordionTab>
        </form>
      </p-accordion>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="filter-sidebar-buttons-container">
      <app-button innerId="btn-F5HLagnK" label="Limpiar" styleClass="secondary" [disabled]="!hasActiveFiltersInForm" (action)="clearFilters()" />
      <app-button innerId="btn-jA128ZK2" label="Aplicar" styleClass="primary" [disabled]="form.invalid" (action)="filter()" />
    </div>
  </ng-template>
</p-sidebar>
